import { MsalModule, MsalInterceptor, MsalService, MsalBroadcastService, ProtectedResourceScopes } from '@azure/msal-angular';
import { PublicClientApplication, InteractionType, LogLevel } from '@azure/msal-browser';
import { environment } from "src/environments/environment.prod";

const apiClientId = environment.clienteId;
const apiTenantId = environment.tenantId;
const clientUri = environment.redirectUrl;
const apiUrl = environment.apiUrl;

export const msalConfig = {
  auth: {
    clientId: apiClientId, 
    authority: `https://login.microsoftonline.com/${apiTenantId}`,
    redirectUri: clientUri,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
    secureCookie: true,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            break;
          case LogLevel.Info:
            console.info(message);
            break;
          case LogLevel.Verbose:
            console.debug(message);
            break;
          case LogLevel.Warning:
            console.warn(message);
            break;
        }
      },
      logLevel: LogLevel.Verbose,
    },
  },
};
export const protectedResourceMap = new Map<string, string[]>([
  [apiUrl, [`api://${apiClientId}/user_impersonation`]] 
]);